import { render, staticRenderFns } from "./DataKategori.vue?vue&type=template&id=1fc9eef6"
import script from "./DataKategori.vue?vue&type=script&lang=js"
export * from "./DataKategori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports